export default __webpack_public_path__ + "static/media/ReviewRequests.315d1f41.svg";